import React from 'react';
import { useTutorial } from '../../context/TutorialContext';
import './WelcomeModal.css';

const WelcomeModal = () => {
  const { showWelcome, returningText, newVisitorText, startTutorial, skipTutorial } = useTutorial();

  if (!showWelcome) return null;

  return (
    <div className="welcome-modal-overlay">
      <div className="welcome-modal-card">
        {/* Rainbow's Image */}
        <div className="rainbow-image-container">
          <img 
            src="/rainbow-assistant.jpg" 
            alt="Rainbow - Your AI Assistant" 
            className="rainbow-image"
          />
        </div>

        {/* Welcome Message */}
        <div className="welcome-content">
          <h1 className="welcome-title">
            Welcome to Rainbow Sails! 🌈
          </h1>
          
          <p className="welcome-message">
            Hey there, amazing human! I'm Rainbow, your friendly AI guide and Zee's digital sidekick. 
            I'm here to make your journey through this creative wonderland absolutely delightful!
          </p>
          
          <p className="welcome-question">
            Quick question - are you a returning explorer or a fresh adventurer?
          </p>

          {/* Optional: Video placeholder for later */}
          {/* <div className="welcome-video-container">
            <video className="welcome-video" controls>
              <source src="/rainbow-welcome.mp4" type="video/mp4" />
            </video>
          </div> */}
        </div>

        {/* Action Buttons */}
        <div className="welcome-buttons">
          <button 
            className="welcome-btn welcome-btn-returning"
            onClick={skipTutorial}
          >
            {returningText}
          </button>
          
          <button 
            className="welcome-btn welcome-btn-new"
            onClick={startTutorial}
          >
            {newVisitorText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
